import React, { useEffect, useState } from 'react';
import GiftDetailsCard from './Components/GiftDetailsCard';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getgiftDetailAction } from './APIs/action';

const RewardDetails = () => {
  const location = useLocation();
  const giftid = location.state?.gift_id || {};
  const type = location.state?.type || {};

  const [loading, setLoading] = useState(false);
  const [giftData, setGiftData] = useState({});

  const fetchGiftDetails = async () => {
    setLoading(true);
    try {
      const { data, message, error } = await getgiftDetailAction(giftid, type);
      setLoading(false);
      if (!error) {
        setGiftData(data);
      } else {
        toast.error(message);
      }
    } catch (err) {
      setLoading(false);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    if (giftid) {
      fetchGiftDetails();
    }
  }, [giftid]);

  return (
    <div style={{ padding: '20px' }}>
      <GiftDetailsCard
        data={giftData}
        type={type}
        onRefresh={() => fetchGiftDetails()}
      />
    </div>
  );
};

export default RewardDetails;
